const RAYS = Array.from({ length: 16 }).map((_, i) => {
  const a = (i / 16) * Math.PI * 2;
  return {
    id: `ray-${i}`,
    x1: 60 + Math.cos(a) * 42,
    y1: 60 + Math.sin(a) * 42,
    x2: 60 + Math.cos(a) * 56,
    y2: 60 + Math.sin(a) * 56,
  };
});

export const BrandMark = ({ size = 40, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 120 120" fill="none" className={className} aria-hidden="true">
    {/* radiating rays */}
    <g stroke="#D8B56A" strokeWidth="0.7" opacity="0.5">
      {RAYS.map((r) => (
        <line key={r.id} x1={r.x1} y1={r.y1} x2={r.x2} y2={r.y2} />
      ))}
    </g>
    {/* three overlapping circles */}
    <g stroke="#D8B56A" strokeWidth="1.3" opacity="0.95">
      <circle cx="60" cy="46" r="30" />
      <circle cx="44" cy="72" r="30" />
      <circle cx="76" cy="72" r="30" />
    </g>
    {/* central vesica leaf + eye */}
    <g>
      <path d="M40 62 Q60 44 80 62 Q60 80 40 62 Z" fill="rgba(216,181,106,0.10)" stroke="#D8B56A" strokeWidth="1.6" />
      <circle cx="60" cy="62" r="8" fill="none" stroke="#D8B56A" strokeWidth="1.6" />
      <circle cx="60" cy="62" r="3" fill="#D8B56A" />
    </g>
  </svg>
);
